import { createSelector } from 'reselect';
import { OVERVIEW, GOAL_CHART_MAP, RETIREMENT_GOAL_TYPE } from './RetirementConstants';
import { goalViewState as goalViewStateSelector } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { goals as goalsSelector, data as financialPlanSelector } from '../FinancialPlanSelector';

export const selectedSectionSelector = createSelector(
  goalViewStateSelector,
  goalViewState => goalViewState.selectedSection || OVERVIEW,
);

export const printTitleSelector = createSelector(
  financialPlanSelector,
  data => data.title || 'Retirement',
);

export const retirementGoalSelector = createSelector(goalsSelector, goals =>
  goals.find(goal => goal.GoalType === RETIREMENT_GOAL_TYPE),
);

export const hasChartSelector = (selectedSection, goal) => {
  const chartTitle = GOAL_CHART_MAP[selectedSection];
  return (
    chartTitle &&
    goal.GoalCharts &&
    Array.isArray(goal.GoalCharts) &&
    goal.GoalCharts.find(goalChart => goalChart.Title === chartTitle)
  );
};

export const getSelectedGoalChart = (selectedSection, goal) => {
  if (hasChartSelector(selectedSection, goal)) {
    const chartTitle = GOAL_CHART_MAP[selectedSection];
    return goal.GoalCharts.find(goalChart => goalChart.Title === chartTitle);
  }
  return null;
};

export const retirementAssumptionsSelector = createSelector(
  retirementGoalSelector,
  ({ GoalAssumptions }) => GoalAssumptions,
);
